var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_82835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8998 2.1001L20.7998 3.5151L22.2138 13.4151L13.0218 22.6071C12.8343 22.7946 12.58 22.8999 12.3148 22.8999C12.0497 22.8999 11.7954 22.7946 11.6078 22.6071L1.70783 12.7071C1.52035 12.5196 1.41504 12.2653 1.41504 12.0001C1.41504 11.7349 1.52035 11.4806 1.70783 11.2931L10.8998 2.1001ZM13.7278 10.5861C14.0075 10.8659 14.3639 11.0564 14.7519 11.1336C15.1398 11.2108 15.542 11.1713 15.9075 11.0199C16.273 10.8686 16.5854 10.6122 16.8052 10.2833C17.0249 9.95439 17.1423 9.56769 17.1423 9.1721C17.1423 8.77651 17.0249 8.38981 16.8052 8.06089C16.5854 7.73198 16.273 7.47564 15.9075 7.32428C15.542 7.17292 15.1398 7.13335 14.7519 7.21057C14.3639 7.28779 14.0075 7.47833 13.7278 7.7581C13.3529 8.13315 13.1423 8.64177 13.1423 9.1721C13.1423 9.70243 13.3529 10.211 13.7278 10.5861Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_82835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListedIcon);
export default __webpack_public_path__ + "static/media/listed-icon.75f34e0d9128ed5dc54f9f21ce8df7c0.svg";
export { ForwardRef as ReactComponent };